import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { LottieSpinner } from '@/components/LottieSpinner/LottieSpinner'
import { useStripe } from '@/hooks/Stripe/useStripe'
import { trackCreditsTopupStarted } from '@/utils/analytics'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

import { StatusCard } from './StatusCard'

export const TopupCreditsCard = ({
  stripeCustomerId,
}: {
  stripeCustomerId: string | undefined
}) => {
  const { t } = useTranslation()
  const { generateCheckoutTopupSession } = useStripe()

  const [isLoadingCheckoutSession, setIsLoadingCheckoutSession] =
    useState(false)

  const handleTopupClick = async () => {
    if (!stripeCustomerId) {
      return
    }

    setIsLoadingCheckoutSession(true)

    try {
      const topupSession = await generateCheckoutTopupSession(stripeCustomerId)

      if (topupSession?.url) {
        // Track credits topup started when user clicks to open Checkout Session
        trackCreditsTopupStarted()
        window.open(topupSession.url, '_blank', 'noopener,noreferrer')
      }
    } catch (error) {
      console.error('Error generating topup session:', error)
    } finally {
      setIsLoadingCheckoutSession(false)
    }
  }

  return (
    <div className="w-1/2 max-md:w-full max-lg:w-3/4">
      <StatusCard
        accentColor={SocialMirrorPalette.alertBlueSecondary}
        bgColor={SocialMirrorPalette.alertBlueBase}
        isLoading={isLoadingCheckoutSession}
        text={t('dashboard.home.topupCredits.text')}
        callback={handleTopupClick}
      />
    </div>
  )
}
